import { render, staticRenderFns } from "./AccordionTeaserItem.vue?vue&type=template&id=8eaa34d0"
import script from "./AccordionTeaserItem.vue?vue&type=script&lang=ts"
export * from "./AccordionTeaserItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports